import React from 'react';

// Customer-facing stand-in for a price when PRICE_TIER_MODE is on.
//
// The server resolves which band an item falls into and sends only the label and
// its colors — the price itself is not in the payload, so there is nothing here
// to hide or format. The label always renders alongside the color because colour
// alone is not a usable cue for a colourblind shopper.
const PriceTierBadge = ({ tier, size = 'large', style = {} }) => {
  if (!tier?.label) return null;

  const large = size === 'large';

  return (
    <span
      style={{
        display: 'inline-block',
        backgroundColor: tier.bg_color || '#000000',
        color: tier.fg_color || '#FFFFFF',
        border: '1px solid rgba(0,0,0,0.25)',
        borderRadius: large ? 8 : 4,
        padding: large ? '4px 20px' : '1px 8px',
        fontSize: large ? '2rem' : '0.75rem',
        fontWeight: 700,
        lineHeight: 1.35,
        whiteSpace: 'nowrap',
        ...style,
      }}
    >
      {tier.label}
    </span>
  );
};

export default PriceTierBadge;
